import React, { useState } from "react";
import {
  NotificationOutlined,
  HomeOutlined,
  MobileOutlined,
  SettingOutlined,
  ShoppingOutlined,
  LogoutOutlined,
  PlusOutlined,
  EditOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Breadcrumb, Layout, Menu, Modal, theme } from "antd";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import pokeFondo from "../Assets/6R0Q1DU.jpeg";
import { Navbar } from "../common/Colores";

const { Header, Content, Footer, Sider } = Layout;

const AdminLayout = () => {
  const location = useLocation();
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });

  const handleLogout = () => {
    localStorage.clear();
    window.history.pushState({}, "", "/login");
    window.location.reload();
  };

  const rutas = [
    { path: "/home", key: "0" },
    { path: "/administrar", key: "1" },
    { path: "/editar", key: "2" },
    { path: "/pokemon", key: "3" },
    { path: "/codigos", key: "4" },
    { path: "/perfil", key: "5" },
    { path: "/configuracion", key: "6" },
  ];

  const getActiveKey = () => {
    const match = rutas.find(r => location.pathname.startsWith(r.path));
    return match ? match.key : "4";
  };

  let navigate = useNavigate();
  const itemsMovil = [
    {
      key: "0",
      icon: (
        <UserOutlined
          style={{
            color:
              rutas.find(r => location.pathname.startsWith(r.path))?.key === "0"
                ? Navbar.btnActivo
                : Navbar.btns,
            margin: "0 10px",
          }}
        />
      ),
      onClick: () => navigate("/administrarUsuarios"),
    },
    {
      key: "1",
      icon: (
        <svg
          viewBox="0 0 1024 1024"
          width="1.5em"
          height="1.5em"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M512 64c247.4 0 448 200.6 448 448H64C64 264.6 264.6 64 512 64z" fill="#E3350D" />
          <path d="M960 512c0 247.4-200.6 448-448 448S64 759.4 64 512h896z" fill="#FFFFFF" stroke="#000" stroke-width="16" />
          <path d="M960 512H64" stroke="#000" stroke-width="48" />
          <circle cx="512" cy="512" r="128" fill="#FFF" stroke="#000" stroke-width="32" />
          <circle cx="512" cy="512" r="64" fill="#000" />
        </svg>
      ),
      onClick: () => navigate("/pokemon"),
    },
    {
      key: "3",
      icon: (
        <svg
          viewBox="0 0 1024 1024"
          width="1.5em"
          height="1.5em"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
           <rect x="256" y="395" width="612" height="100" fill="#6B676E" />
           <rect x="320" y="560" width="484" height="100" fill="#6B676E" />
        </svg>
      ),
      onClick: () => navigate("/editar"),
    },
    {
      key: "4",
      icon: (
        <svg
          viewBox="0 0 1024 1024"
          width="1.5em"
          height="1.5em"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="320" y="320" width="684" height="584" fill="#6B676E" />
          <rect x="380" y="352" width="550" height="68" fill="#FFFFFF" />
          <rect x="380" y="460" width="550" height="68" fill="#FFFFFF" />
          <rect x="380" y="580" width="550" height="68" fill="#FFFFFF" />
        </svg>
      ),
      onClick: () => navigate("/codigos"),
    },
    {
      key: "6",
      icon: (
        <SettingOutlined
          style={{
            color:
              rutas.find(r => location.pathname.startsWith(r.path))?.key === "6"
                ? Navbar.btnActivo
                : Navbar.btns,
            margin: "0 10px",
          }}
        />
      ),
      onClick: () => navigate("/configuracion"),
    },
    {
      key: "5",
      icon: <EditOutlined style={{ color: rutas.find(r => location.pathname.startsWith(r.path))?.key === "5" ? Navbar.btnActivo : Navbar.btns, margin: "0 10px" }} />,
      onClick: () => navigate("/perfil"),
    },
    {
      key: "7",
      icon: (
        <LogoutOutlined
          style={{
            color:
              !rutas.find(r => location.pathname.startsWith(r.path))
                ? Navbar.btnActivo
                : Navbar.btns,
            margin: "0 10px",
          }}
        />
      ),

      onClick: () => {
        Modal.confirm({
          title: "Cerrar Sesión",
          content: "¿Seguro que quiere cerrar sesión?",
          centered: true,
          footer: (_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          ),
          onOk: handleLogout,
        });
      },
    },
  ];

  const itemDesktop = [
    {
      label: "Usuarios",
      key: "0",
      icon: (
        <svg
          viewBox="0 0 1024 1024"
          width="1.5em"
          height="1.5em"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="512" cy="320" r="128" fill="#6B676E" />
          <path
            d="M320 704c0-96 96-160 192-160s192 64 192 160v96H320v-96z"
            fill="#6B676E"
          />
        </svg>
      ),
      onClick: () => navigate("/administrarUsuarios"),
    },
    {
      label: "Pokémon",
      key: "1",
      icon: (
        <svg
          viewBox="0 0 1024 1024"
          width="1.5em"
          height="1.5em"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M512 64c247.4 0 448 200.6 448 448H64C64 264.6 264.6 64 512 64z" fill="#E3350D" />
          <path d="M960 512c0 247.4-200.6 448-448 448S64 759.4 64 512h896z" fill="#FFFFFF" stroke="#000" stroke-width="16" />
          <path d="M960 512H64" stroke="#000" stroke-width="48" />
          <circle cx="512" cy="512" r="128" fill="#FFF" stroke="#000" stroke-width="32" />
          <circle cx="512" cy="512" r="64" fill="#000" />
        </svg>
      ),
      onClick: () => navigate("/pokemon"),
    },
    {
      label: "Ventas",
      key: "2",
      icon: (
        <svg
          viewBox="0 0 1024 1024"
          width="1.5em"
          height="1.5em"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="320" y="320" width="684" height="584" fill="#6B676E" />
          <rect x="380" y="352" width="550" height="68" fill="#FFFFFF" />
          <rect x="380" y="460" width="550" height="68" fill="#FFFFFF" />
          <rect x="380" y="580" width="550" height="68" fill="#FFFFFF" />
        </svg>
      ),
      onClick: () => navigate("/codigos"),
    },
    {
      label: "Administrar",
      key: "3",
      icon: (
        <svg
          viewBox="0 0 1024 1024"
          width="1.5em"
          height="1.5em"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
           <rect x="256" y="395" width="612" height="100" fill="#6B676E" />
           <rect x="320" y="560" width="484" height="100" fill="#6B676E" />
        </svg>
      ),
      onClick: () => navigate("/editar"),
    },
    {
      label: "Configuracion",
      key: "4",
      icon: <SettingOutlined style={{ fontSize: "1.5em" }} />,
      onClick: () => navigate("/configuracion"),
    },
    {
      label: "Mi Perfil",
      key: "5",
      icon: <EditOutlined style={{ fontSize: "1.5em" }} />,
      onClick: () => navigate("/perfil"),
    },
    {
      label: "Cerrar sesión",
      key: "6",
      icon: <LogoutOutlined style={{ fontSize: "1.5em" }} />,
      onClick: () => {
        Modal.confirm({
          title: "Cerrar Sesión",
          content: "¿Seguro que quiere cerrar sesión?",
          centered: true,
          footer: (_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          ),
          onOk: handleLogout,
        });
      },
    },
  ];


  const [collapsed, setCollapsed] = useState(false);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {isDesktopOrLaptop && (
        <Sider
          style={{
            zIndex: 10,
            position: "fixed",
            height: "100vh",
            left: 0,
            top: 0,
          }}
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
          width={200}
        >
          <div
            style={{
              backgroundColor: "#334454",
              marginTop: "20%",
              margin: "1rem",
              padding: "0.5rem",
              alignItems: "center",
              borderRadius: "0.5rem",
            }}
          >
            <h3 style={{ color: "#FFFF", textAlign: "center" }}>
              {collapsed ? "WP" : "WONDER PIECE"}
            </h3>
          </div>
          <Menu
            theme="dark"
            defaultSelectedKeys={[getActiveKey()]}
            mode="inline"
            items={itemDesktop}
          />
        </Sider>
      )}
      <Content
        style={
          isDesktopOrLaptop
            ? {
                margin: "24px 16px 0 200px", // margen izquierdo igual al ancho del sidebar
                overflow: "initial",
              }
            : {}
        }
      >
        <div
          style={{
            height: "100%",
            width: "100%",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: `url(${pokeFondo})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              zIndex: 0,
              opacity: 0.4,
            }}
          />
          {/* <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.1)", 
              zIndex: 1,
            }}
          /> */}

          <div style={{ position: "relative" }}>
            <Outlet />
          </div>
        </div>
      </Content>
      {!isDesktopOrLaptop && (
        <Header
          style={{
            position: "sticky",
            bottom: 0,
            zIndex: 10,
            width: "100%",
            display: "flex",
            alignItems: "center",
            backgroundColor: Navbar.background,
          }}
        >
          <div className="demo-logo" />
          <Menu
            theme="dark"
            mode="horizontal"
            defaultSelectedKeys={[getActiveKey()]}
            items={itemsMovil}
            style={{
              backgroundColor: Navbar.background,
              flex: 1,
              justifyContent: "center",
              display: "flex",
            }}
          />
        </Header>
      )}
    </Layout>
  );
};

export default AdminLayout;
